<div class="container-fluid"> 
</div>
<div *ngIf="displayCr">
    <app-display-ticket-cr [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
        [groupName]="groupName" [grpLevel]="grpLevel" [notifier]="notifier" [seq]="seq" [isViewTicket]="isViewTicket">
    </app-display-ticket-cr>
</div>
<div *ngIf="displayPr">
    <app-display-ticket-pr [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
        [groupName]="groupName" [grpLevel]="grpLevel" [notifier]="notifier" [seq]="seq" [isViewTicket]="isViewTicket">
    </app-display-ticket-pr>
</div>
<div *ngIf="displayCit">
    <app-display-ticket-jusco [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
        [groupName]="groupName" [grpLevel]="grpLevel" [notifier]="notifier" [seq]="seq" [view_seq]="viewSeq"
        [isViewTicket]="isViewTicket">
    </app-display-ticket-jusco>
</div>

<notifier-container></notifier-container>